<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"> 评估任务</i>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="150px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="单位名称" prop="company_num" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-select v-model="form.company_num" disabled>
              <el-option v-for="(item, index) in units" :key="index" :label="item.c_name" :value="item.c_company_num"> {{ item.c_name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="报告名称" prop="project_name" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.project_name" placeholder="建议输入xx年评估报告"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="执行人" prop="person" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.person" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="开始时间" prop="start_time" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-date-picker v-model="form.start_time" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="结束时间" prop="end_time" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-date-picker v-model="form.end_time" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <!-- @change="compute($event, 3)" -->
            <el-input type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="btn-box">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import getLoation from './getLoation'
import OSS from "ali-oss";

export default {
  components: {},
  data() {
    return {
      form: {
        company_num: this.$route.query.id,
        project_name: "",
        person: "",
        start_time: "",
        end_time: "",
        end_time: "",
        remark: "", //备注
      },
      units: [],

      rules: {},
    };
  },
  created() {
    this.$post("/devicemanage/selectconpanybyme").then((res) => {
      this.units = res.data;
    });
    //   this.form.cz_company_num = this.$route.query.c_num

    if (this.$route.query.type) {
      this.$post("/score/maintenanceDetailsRedact", {
        uuid: this.$route.query.id,
      }).then((res) => {
        this.form = res.data;
      });
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      // console.log(this.$route.query.type);
      let api = this.$route.query.type ? "/score/maintenanceAssessUpdate" : "/score/maintenanceAssessInsert";
      // console.log(this.form);
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          this.$router.back();
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
